export enum Subject {
    Fotovoltika, 
    Kontakt
}